import React, { useEffect, useState } from "react";
import http from "../../../http";
// import Modal from "react-modal";
import MaterialTable from "material-table";
import Swal from "sweetalert2";
import Select from "react-select";
import { memberLang } from "../../../Components/language/pages/memberLang";
import useLanguage from "../../../Components/language/useLanguage";
import { Modal as ReactModal } from "../../../Components/Common/Modal";

export default function Customers() {
  const [update, setUpdate] = useState("members");
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [country, setCountry] = useState([]);
  const lan = useLanguage(memberLang);
  useEffect(() => {
    http.get(`customers/customer`).then((res) => {
      setData(res.data.data);
      setIsLoading(false);
    });
    http.get('country').then((res) => {
      if (res.status === 200) {
        setCountry(res.data.data);
      }
    });
  }, [update]);
  // const { data, isLoading } = useQuery(update, () => http.get(`members`).then(res => res.data.data));
  const columns = [
    {
      title: lan?.sl,
      field: "",
      render: (row) => (
        <div className="text-center">{row.tableData.id + 1}</div>
      ),
      width: "20 !important",
    },

    {
      title: lan?.name,
      field: `member_name`,
    },
    {
      title: lan?.address,
      field: `address`,
    },
    {
      title: lan?.mobile,
      field: `mobile`,
    },
    {
      title: lan?.email,
      field: `member_email`,
      cellStyle: {
        textAlign: "center",
      },
    },
    {
      title: lan?.contactPerson,
      field: `contact_person`,
      cellStyle: {
        textAlign: "center",
      },
    },
    {
      title: lan?.shortName,
      field: `short_name`,
      cellStyle: {
        textAlign: "center",
      },
    },

    {
      title: lan?.action,
      field: "patient",
      render: (row) => (
        <div className="text-center">
          <button
            onClick={() => editData(row.id)}
            className="btn btn-sm action-btn"
          >
            <i className="far fa-edit"></i>
          </button>
          &nbsp;
          <button
            onClick={() => deleteRowData(row.id)}
            className="btn btn-sm action-btn"
          >
            <i className="far fa-trash"></i>
          </button>
        </div>
      ),
      cellStyle: {
        width: "5%",
        textAlign: "center",
      },
    },
  ];
  const [member, setMember] = useState({
    member_name: "",
    member_email: "",
    member_phone: "",
    member_type: "customer",
  });
  const [isOpen, setIsOpen] = useState(false);
  const submitData = (e) => {
    e.preventDefault();
    if (member?.id) {
      http.post(`members-update/${member.id}`, member).then((res) => {
        if (res.data.status === 200) {
          Swal.fire({
            position: "top-center",
            icon: "success",
            title: `Dealer Updated Successfully`,
            timer: 2500,
          });

          setIsOpen(false);
          setUpdate(!update);
          setMember({
            member_name: "",
            member_email: "",
            member_phone: "",
            member_type: "customer",
          });
        }
      });
    } else {
      http.post("members", member).then((res) => {
        if (res.data.status === 200) {
          Swal.fire({
            position: "top-center",
            icon: "success",
            title: `<div><h1 style={{color:'green'}}>Congratulations!</h1><h4>${member.member_name}</h4> <h6>You are now our member</h6></div>`,
            timer: 2500,
          });

          setIsOpen(false);
          setUpdate(!update);
          setMember({
            member_name: "",
            member_email: "",
            member_phone: "",
            member_type: "customer",
          });
        } else {
        }
      });
    }
  };

  const handleInput = (e) => [
    setMember({ ...member, [e.target.name]: e.target.value }),
  ];
  const editData = (id) => {
    http.get(`members/${id}`).then((res) => {
      setMember(res.data.data);
      setIsOpen(true);
    });
  };
  const deleteRowData = (id) => {
    Swal.fire({
      title: lan?.warning,
      text: lan?.youWontRevertIt,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: lan?.yes,
    }).then((result) => {
      if (result.isConfirmed) {
        http.delete(`members/${id}`).then((res) => {
          setUpdate(!update);
          setIsOpen(false);
          Swal.fire({
            position: "top-center",
            icon: "success",
            title: "Success !",
            showConfirmButton: false,
            timer: 1500,
          });
        });
      }
    });
  };
  const closeModal = () => {
    setIsOpen(false);
    setMember({
      member_name: "",
      member_email: "",
      member_phone: "",
      member_type: "customer",
    });
  };
  return (
    <div className="page-content adjustment-type-table">
      <div className="custom-card p-2 d-flex justify-content-between mb-2 align-items-center">
        <h6>{lan?.pageTitle}</h6>
        <div>
          <button
            style={{ marginTop: "1px" }}
            onClick={() => setIsOpen(true)}
            className="btn btn-sm btn-primary float-end"
          >
            {lan?.addMember}
          </button>
        </div>
      </div>
      <div className="data-table-container">
        <MaterialTable
          columns={columns}
          data={data}
          isLoading={isLoading}
          options={{
            search: true,
            showTitle: false,
            searchFieldAlignment: "left",
            pageSize: 10,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [5, 10, 20, 50, 100],
          }}
        />
      </div>

      <ReactModal isOpen={isOpen} onClose={closeModal} size="lg" width="100%">
        <ReactModal.Header onClose={closeModal}>
          <ReactModal.Title>
            {member.id ? lan?.editMembershipForm : lan?.addMembershipForm}
          </ReactModal.Title>
        </ReactModal.Header>
        <ReactModal.Body>
          <div className="product_modal">
            <div className="new-member-reg p-2">
              <form onSubmit={submitData}>
                <div className="row">
                  <div className="col-6">
                    <div className="form-group mb-2">
                      <label>
                        {lan?.name} <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="member_name"
                        value={member?.member_name}
                        onChange={handleInput}
                        required
                        placeholder="Enter Customer Name"
                      />
                    </div>
                    <div className="form-group mb-2">
                      <label>
                        {lan?.mobile} <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        name="mobile"
                        value={member?.mobile}
                        onChange={handleInput}
                        required
                        placeholder="Enter Mobile Number"
                      />
                    </div>
                    <div className="form-group mb-2">
                      <label>{lan?.phone}</label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        name="member_phone"
                        value={member?.member_phone}
                        onChange={handleInput}
                        placeholder="Enter Phone Number"
                      />
                    </div>

                    <div className="form-group mb-2">
                      <label>
                        {lan?.address} <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="address"
                        value={member?.address}
                        onChange={handleInput}
                        placeholder="Enter Address"
                      />
                    </div>
                    <div className="form-group mb-2">
                      <label>{lan?.contactPerson} </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="contact_person"
                        value={member?.contact_person}
                        onChange={handleInput}
                        placeholder="Enter Contact Person"
                      />
                    </div>
                  {/* ===== City / State Field ===== */}
                    <div className="form-group mb-2">
                     <label>{lan?.cityState || "City / State"}</label>
           
                      <input type="text" className="form-control form-control-sm"name="city_state"
                         value={member?.city_state}
                         onChange={handleInput}
                         placeholder="Enter City / State"
                       />
                     </div>

                  {/* ===== Zip Code Field ===== */}
                   <div className="form-group mb-2">
                     <label>{lan?.zipCode || "Zip Code"}</label>
                     <input type="text"className="form-control form-control-sm"name="zip_code"
                        value={member?.zip_code}
                        onChange={handleInput}
                        placeholder="Enter Zip Code"
                     />
                  </div>


                    
                  </div>
                  <div className="col-6">
                    <div className="form-group mb-2">
                      <label>{lan?.whatsapp}</label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        name="whatsapp"
                        value={member?.whatsapp}
                        onChange={handleInput}
                        placeholder="Enter Whatsapp Number"
                      />
                    </div>
                    <div className="form-group mb-2">
                      <label>{lan?.imo}</label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        name="imo"
                        value={member?.imo}
                        onChange={handleInput}
                        placeholder="Enter Imo Number"
                      />
                    </div>
                    <div className="form-group mb-2">
                      <label>{lan?.shortName}</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="short_name"
                        value={member?.short_name}
                        onChange={handleInput}
                        placeholder="Enter Short Name"
                      />
                    </div>
                    <div className="form-group mb-2">
                      <label>{lan?.email}</label>
                      <input
                        type="email"
                        className="form-control form-control-sm"
                        name="member_email"
                        value={member?.member_email}
                        onChange={handleInput}
                        placeholder="Enter Email"
                      />
                    </div>

                    {/* ===== Country Field ===== */}
                      <div className="form-group mb-2">
                       <label>
                        {lan?.country || "Country"}
                       </label>
                       <Select
                         options={country}
                         onChange={(selectedCountry) =>
                           setMember({ ...member, country: selectedCountry?.country_name || "" })
                         }
                         placeholder="Select Country"
                         isSearchable={true}
                         getOptionLabel={(country) => `${country.country_name}`}
                         getOptionValue={(country) => `${country.country_name}`}
                         value={country.find(
                           (c) => c.country_name === member?.country
                         ) || null}
                         styles={{
                           control: (base) => ({
                             ...base,
                             minHeight: '31px',
                             fontSize: '0.875rem',
                           }),
                           option: (base) => ({
                             ...base,
                             fontSize: '0.875rem',
                           }),
                         }}
                       />
                    </div>

                      {/* ===== Lead Source Field ===== */}
                      <div className="form-group mb-2">
                         <label>{lan?.leadSource || "Lead Source"}</label>

                          <select
                              className="form-control form-control-sm"name="lead_source"
                               value={member?.lead_source || ""} // 🔥 empty string ensures placeholder shows
                               onChange={handleInput}
                               style={{ color: member?.lead_source ? "#212529" : "#6c757d" }} 
                           >
                            {/* Placeholder */}
                            <option value="" disabled hidden>Select Lead Source</option>
                            <option value="website">Website</option>
                            <option value="facebook">Facebook</option>
                            <option value="reference">Reference</option>
                            <option value="walk_in">Walk In</option>
                          </select>
                     </div>



                    <div className="row">
                      <div className="col-6">
                        <div className="form-group mb-2">
                          <label>{lan?.due}</label>
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            name="due"
                            value={member?.due}
                            onChange={handleInput}
                            placeholder="Enter Email"
                          />
                        </div>
                      </div>
                      <div className="col-6  ">
                        <label> </label>
                        <div className="d-flex justify-content-end">
                          <button
                            onClick={() => setIsOpen(false)}
                            className="custom-btn-outline me-2"
                            type="button"
                          >
                            {lan?.cancel}
                          </button>
                          <button className="custom-btn" type="submit">
                            {lan?.submit}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </ReactModal.Body>
      </ReactModal>
    </div>
  );
}
